export type GalleryCategory =
  | "All"
  | "Workshop"
  | "CNC Laser Cutting"
  | "Press Brake Bending"
  | "Welding & Fabrication"
  | "Tube Fabrication"
  | "Powder Coating"
  | "Epoxy Coating"
  | "Industrial Supply"
  | "Deliveries"
  | "Team at Work";

export interface GalleryImage {
  src: string;
  alt: string;
  category: GalleryCategory;
}

export const GALLERY_CATEGORIES: GalleryCategory[] = [
  "All",
  "Workshop",
  "CNC Laser Cutting",
  "Press Brake Bending",
  "Welding & Fabrication",
  "Tube Fabrication",
  "Powder Coating",
  "Epoxy Coating",
  "Industrial Supply",
  "Deliveries",
  "Team at Work",
];

export const GALLERY_IMAGES: GalleryImage[] = [
  {
    src: "/images/gallery/workshop-1.jpg",
    alt: "Workshop floor showing organized fabrication activities",
    category: "Workshop",
  },
  {
    src: "/images/gallery/laser-cutting-1.jpg",
    alt: "CNC laser cutting in progress with sparks",
    category: "CNC Laser Cutting",
  },
  {
    src: "/images/gallery/bending-1.jpg",
    alt: "Press brake bending operation",
    category: "Press Brake Bending",
  },
  {
    src: "/images/gallery/welding-1.jpg",
    alt: "Welding process with bright arc",
    category: "Welding & Fabrication",
  },
  {
    src: "/images/gallery/tube-fabrication-1.jpg",
    alt: "Tube cutting and welding operation",
    category: "Tube Fabrication",
  },
  {
    src: "/images/gallery/powder-coating-1.jpg",
    alt: "Powder coating spray application",
    category: "Powder Coating",
  },
  {
    src: "/images/gallery/epoxy-coating-1.jpg",
    alt: "Epoxy coating process",
    category: "Epoxy Coating",
  },
  {
    src: "/images/gallery/supply-1.jpg",
    alt: "Material supply warehouse",
    category: "Industrial Supply",
  },
  {
    src: "/images/gallery/delivery-1.jpg",
    alt: "Organized materials ready for delivery",
    category: "Deliveries",
  },
  {
    src: "/images/gallery/team-1.jpg",
    alt: "Team members at work",
    category: "Team at Work",
  },
];
